const initialState = {
  isLoading: false,
  query: '',
  suggestions: [],
  latestRequestFinished: 0
};

export function searchQuery (state = initialState, action) {
  switch (action.type) {
    case 'QUERY_INPUT':
      return {
        ...state,
        query: action.query,
        suggestions: action.query === '' ? [] : state.suggestions
      };
    case 'QUERY_LOADING':
      return {
        ...state,
        isLoading: true
      };
    case 'QUERY_SUCCESS':
      return {
        ...state,
        isLoading: false,
        suggestions: action.suggestions,
        latestRequestFinished: action.latestRequestFinished
      };
    default:
      return state;
  }
}
